export default "assets/images/guard-de7a0954.svg";